export const NODEJS_DEPLOY_FORM_URL = 'https://form.typeform.com/to/mIFOfXsa?typeform-source=statics.teams.cdn.office.net';
